const priority = {
	LOW: 3,
	MEDIUM: 2,
	HIGH: 1,
	ALL: -1,
};

export default priority;
